import React from 'react';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from '../../../store';
import './Footer.css';

const Footer: React.FC = () => {
  const { navigation } = useSelector((state: RootState) => state.cms);
  const footerSections = [
    {
      title: 'Top Category',
      links: [
        { name: 'About us', path: '/about' },
        { name: 'Press', path: '/press' },
        { name: 'Testimonials', path: '/testimonials' },
        { name: 'Blogs', path: '/blogs' },
        { name: 'Articles', path: '/articles' },
      ],
    },
    {
      title: 'Help',
      links: [
        { name: 'Contact us', path: '/contact' },
        { name: 'Track My Order', path: '/track/search' },
        { name: 'Buying Guide', path: '/buying-guide' },
      ],
    },
    {
      title: 'Support',
      links: [
        { name: 'FAQ', path: '/faq' },
        { name: 'Cancellation and Return', path: '/cancellation' },
        { name: 'Refund', path: '/refund' },
        { name: 'Payment Options', path: '/payment-options' },
        { name: 'Term and Conditions', path: '/terms' },
      ],
    },
    {
      title: "Industry bull Own's",
      links: [
        { name: 'Popular Search', path: '/popular-search' },
        { name: 'Best Deal', path: '/best-deal' },
        { name: 'Online Assist', path: '/online-assist' },
        { name: 'Industry Store', path: '/industry-store' },
        { name: 'Top Buying requirement', path: '/top-buying' },
      ],
    },
  ];

  return (
    <footer className="footer">
      <div className="footer__container">
        <div className="footer__top">
          {/* Brand Column */}
          <div className="footer__brand">
            <Link to="/" className="footer__logo-img-link">
              <img src="/assets/images/footerlogo.png" alt="Industrybull" className="footer__logo-img" />
            </Link>
            
            <div className="footer__customer-supports">
              <h4 className="footer__customer-supports-title">Customer Supports:</h4>
              <p className="footer__customer-supports-text">
                {navigation.contactNumber}<br/>
                D-14/1 Om Nagar, Badarpur New Delhi- 110044<br/>
                {navigation.email}
              </p>
            </div>
            
            <div className="footer__social-links">
              {/* Facebook */}
              <a href="https://facebook.com" className="footer__social-link" aria-label="Facebook">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                </svg>
              </a>
              {/* Twitter */}
              <a href="https://twitter.com" className="footer__social-link" aria-label="Twitter">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M23.953 4.57a10 10 0 01-2.825.775 4.958 4.958 0 002.163-2.723c-.951.555-2.005.959-3.127 1.184a4.92 4.92 0 00-8.384 4.482C7.69 8.095 4.067 6.13 1.64 3.162a4.822 4.822 0 00-.666 2.475c0 1.71.87 3.213 2.188 4.096a4.904 4.904 0 01-2.228-.616v.06a4.923 4.923 0 003.946 4.827 4.996 4.996 0 01-2.212.085 4.936 4.936 0 004.604 3.417 9.867 9.867 0 01-6.102 2.105c-.39 0-.779-.023-1.17-.067a13.995 13.995 0 007.557 2.209c9.053 0 13.998-7.496 13.998-13.985 0-.21 0-.42-.015-.63A9.935 9.935 0 0024 4.59z"/>
                </svg>
              </a>
              {/* Instagram */}
              <a href="https://instagram.com" className="footer__social-link" aria-label="Instagram">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zM5.838 12a6.162 6.162 0 1112.324 0 6.162 6.162 0 01-12.324 0zM12 16a4 4 0 110-8 4 4 0 010 8zm4.965-10.405a1.44 1.44 0 112.881.001 1.44 1.44 0 01-2.881-.001z"/>
                </svg>
              </a>
              {/* LinkedIn */}
              <a href="https://linkedin.com" className="footer__social-link" aria-label="LinkedIn">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
                </svg>
              </a>
            </div>
          </div>

          {/* Links Columns */}
          <div className="footer__links-container">
            {footerSections.map((section, index) => (
              <div key={index} className="footer__section">
                <h3 className="footer__section-title">{section.title}</h3>
                <ul className="footer__section-list">
                  {section.links.map((link, linkIndex) => (
                    <li key={linkIndex} className="footer__section-item">
                      <Link to={link.path} className="footer__link">
                        {link.name}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="footer__bottom">
          <div className="footer__bottom-links">
            <Link to="/terms">Term of use</Link>
            <span className="footer__separator">|</span>
            <Link to="/copyright">Copyright</Link>
            <span className="footer__separator">|</span>
            <Link to="/privacy">Privacy Policy</Link>
            <span className="footer__separator">|</span>
            <Link to="/compliance">Compliance</Link>
          </div>
          <p className="footer__copyright">
            Industry Bulls Lab PRIVATE LIMITED © 2026 Industrybull.com. All Rights Reserved
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
